/**
 * 用于 DesignTool 和 PropPanel 的工具方法。
 *
 * 注意， mapCompProp 映射出来的值，是 **未插值** 的结果。如果需要组件实际渲染时，拿到的已插值的结果，请使用 `this.getActualProp("propName")` ！！
 *
 * @param {string} id
 */

export const mapCompProp = id => ({
  get() {
    var _this$comp$props$id, _this$comp$props, _this$defaultProps;
    return (_this$comp$props$id = (_this$comp$props = this.comp.props) === null || _this$comp$props === void 0 ? void 0 : _this$comp$props[id]) !== null && _this$comp$props$id !== void 0 ? _this$comp$props$id : (_this$defaultProps = this.defaultProps) === null || _this$defaultProps === void 0 ? void 0 : _this$defaultProps[id];
  },
  set(v) {
    return this.updateCompProp(id, v);
  }
});
//# sourceMappingURL=mapCompProp.js.map
